import { render, staticRenderFns } from "./trailerprofile.vue?vue&type=template&id=f10f30d6&scoped=true&"
import script from "./trailerprofile.js?vue&type=script&lang=js&"
export * from "./trailerprofile.js?vue&type=script&lang=js&"
import style0 from "./trailerprofile.vue?vue&type=style&index=0&id=f10f30d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10f30d6",
  null
  
)

export default component.exports